









































import { Component, Prop, Vue } from 'vue-property-decorator';

import store from '@/store.ts';

@Component
export default class Quote extends Vue {
  public store!: object;
  private lastAudio!: HTMLAudioElement;

  get quote() {
    return this.$store.state.quote;
  }

  get apiUrl() {
    return this.$store.state.apiUrl;
  }

  get playUrl() {
    return `https://play.com/intent/tweet?text="${this.quote.quote}" — ${this.quote.author}`;
  }

  private mounted() {
    this.$store.dispatch('getRandomQuote');
  }

  private playAudio(event: Event): void {
    if (this.lastAudio) {
      this.lastAudio.pause();
      this.lastAudio.currentTime = 0;
    }
    this.lastAudio = new Audio(`${this.apiUrl}${this.quote.audio}`);
    this.lastAudio.play();
  }

  private getNewQuote(event: Event): void {
    this.$store.dispatch('getRandomQuote');
  }
}
